import { CountUp } from 'countup.js';

export const initStats = () => {
  const stat = document.querySelectorAll('.stat');
  stat.forEach((el) => {
    let options = {
      startVal: Number(el.getAttribute('data-start')),
      duration: Number(el.getAttribute('data-duration')),
      suffix: el.hasAttribute('data-suffix') ? el.getAttribute('data-suffix') : '',
      enableScrollSpy: true,
      scrollSpyOnce: true,
    }
    const countUp = new CountUp(el.querySelector('h4'), el.getAttribute('data-end'), options);
  });
}



// WEBPACK FOOTER //
// ./src/templates/components/our-locations/our-locations.js